module.exports = __webpack_public_path__ + "img/type-4-2.63918e12.png";